import { IWidgetAttribute, IWidgetPayload } from "@livelike/javascript";
import { SoccerMatchCommentaryEventType } from "../../../../../../types";

// Utility function to check if widget should be filtered based on timeMin
export function shouldFilterWidget(widget: IWidgetPayload): boolean {
  if (!widget.widget_attributes || !Array.isArray(widget.widget_attributes)) {
    return false; // Don't filter if no attributes
  }

  const timeMinAttribute = widget.widget_attributes.find(
    (attr: IWidgetAttribute) => attr.key === "timeMin"
  );

  const actionType = widget.widget_attributes.find(
    (attr: IWidgetAttribute) => attr.key === "actionType"
  );
  if (actionType?.value !== SoccerMatchCommentaryEventType.SUBSTITUTION) {
    return false; // Don't filter if actionType is not substitution
  }

  if (!timeMinAttribute || !timeMinAttribute.value) {
    return false; // Don't filter if no timeMin attribute
  }

  const timeMin = parseInt(timeMinAttribute.value, 10);

  // Filter out widgets with timeMin between 50 and 80 (inclusive)
  return timeMin >= 50 && timeMin <= 80;
}
